import { fmtUSD } from "../../lib/api";

export const AnnouncePanel = ({
  d, members, announce, setAnnounce, toggleRecipient, scheduled, responses, busy,
  allocCap, setAllocCap, sendAnnounce, cancelScheduled, remind, saveThreshold,
  allocateWaitlist, allocateAll,
}) => (
  <div className="py-3 space-y-4 max-w-2xl" data-testid="deal-announce-panel">
    <div className="flex items-center gap-5">
      <span className="t-label">Send to</span>
      <label className="flex items-center gap-2 text-bone t-small cursor-pointer">
        <input type="radio" checked={announce.recipients === "all"} onChange={() => setAnnounce({ ...announce, recipients: "all" })} data-testid="announce-all-radio" />
        All members ({members.length})
      </label>
      <label className="flex items-center gap-2 text-bone t-small cursor-pointer">
        <input type="radio" checked={announce.recipients === "selected"} onChange={() => setAnnounce({ ...announce, recipients: "selected" })} data-testid="announce-selected-radio" />
        Selected{announce.recipients === "selected" ? ` (${announce.user_ids.length})` : ""}
      </label>
      {d.pipeline_interest_user_ids?.length > 0 && (
        <button type="button"
          onClick={() => setAnnounce({ ...announce, recipients: "selected", user_ids: d.pipeline_interest_user_ids.filter((id) => members.some((m) => m.user_id === id)) })}
          className="t-label px-2 py-1 border border-[#C69A4E] !text-[#C69A4E] hover:opacity-80 transition-opacity" data-testid="announce-pipeline-interested">
          Pipeline interested ({d.pipeline_interest_user_ids.length})
        </button>
      )}
    </div>
    {announce.recipients === "selected" && (
      <div className="flex flex-wrap gap-2 max-h-40 overflow-auto" data-testid="announce-member-list">
        {members.map((m) => (
          <button key={m.user_id} onClick={() => toggleRecipient(m.user_id)}
            className={`px-3 py-1 border t-small ${announce.user_ids.includes(m.user_id) ? "bg-[#E8E6E1] text-[#0E1012] border-[#E8E6E1]" : "text-muted-s border-[#24272B] hover:border-[#3A3E44]"}`}
            data-testid={`announce-member-${m.user_id}`}>
            {m.name || m.email}
          </button>
        ))}
        {!members.length && <span className="text-muted-s t-small">No members yet.</span>}
      </div>
    )}
    <textarea className="input-solera" rows={2} placeholder="Optional note included in the email, e.g. why this one now"
      value={announce.message} onChange={(e) => setAnnounce({ ...announce, message: e.target.value })} data-testid="announce-message-input" />
    <div className="flex items-center gap-3 flex-wrap">
      <span className="t-label">Schedule</span>
      <input type="datetime-local" className="input-solera max-w-[240px]" value={announce.send_at}
        onChange={(e) => setAnnounce({ ...announce, send_at: e.target.value })} data-testid="announce-schedule-input" />
      {announce.send_at && (
        <button className="t-label hover:!text-[#E8E6E1]" onClick={() => setAnnounce({ ...announce, send_at: "" })} data-testid="announce-schedule-clear">Clear, send now</button>
      )}
    </div>
    <div className="flex items-center gap-3 flex-wrap">
      <span className="t-label">Alert me at</span>
      <input type="number" min="1" className="input-solera fig max-w-[120px]" placeholder="e.g. 5"
        value={announce.threshold} onChange={(e) => setAnnounce({ ...announce, threshold: e.target.value })} data-testid="announce-threshold-input" />
      <span className="text-muted-s t-small">interested</span>
      <button className="t-label hover:!text-[#E8E6E1]" onClick={() => saveThreshold(d.deal_id)} data-testid="announce-threshold-save">Save alert</button>
    </div>
    <button className="btn-primary" disabled={busy || (announce.recipients === "selected" && !announce.user_ids.length)}
      onClick={() => sendAnnounce(d.deal_id)} data-testid="announce-send-button">
      {busy ? "Working" : announce.send_at ? "Schedule announcement" : "Send announcement"}
    </button>
    {scheduled[d.deal_id] && scheduled[d.deal_id].length > 0 && (
      <div className="pt-1" data-testid="announce-scheduled">
        <span className="t-label">Scheduled</span>
        {scheduled[d.deal_id].map((s) => (
          <div key={s.schedule_id} className="flex items-center gap-4 mt-2 t-small">
            <span className="text-bone">{new Date(s.send_at).toLocaleString()}</span>
            <span className="text-muted-s">{s.recipients === "all" ? "All members" : `${s.user_ids.length} selected`}</span>
            <button className="t-label hover:!text-[#E8E6E1]" onClick={() => cancelScheduled(s.schedule_id, d.deal_id)} data-testid={`cancel-scheduled-${s.schedule_id}`}>Cancel</button>
          </div>
        ))}
      </div>
    )}
    {responses[d.deal_id] && responses[d.deal_id].counts.total > 0 && (
      <div className="pt-2" data-testid="announce-summary">
        <div className="flex items-center gap-4">
          <span className="t-label">
            {responses[d.deal_id].counts.commit > 0 ? `${responses[d.deal_id].counts.commit} committed, ` : ""}{responses[d.deal_id].counts.interested} interested, {responses[d.deal_id].counts.pass} passed, {responses[d.deal_id].counts.pending} pending
          </span>
          {responses[d.deal_id].counts.pending > 0 && (
            <button className="t-label hover:!text-[#E8E6E1]" disabled={busy} onClick={() => remind(d.deal_id)} data-testid={`remind-deal-${d.deal_id}`}>Remind pending</button>
          )}
        </div>
        {responses[d.deal_id].oversub?.capacity_usd ? (
          <div className="mt-3" data-testid="oversub-bar">
            <div className="flex justify-between t-cap text-muted-s">
              <span>Indicative demand {fmtUSD(responses[d.deal_id].oversub.indicative_demand)}</span>
              <span>Capacity {fmtUSD(responses[d.deal_id].oversub.capacity_usd)}</span>
            </div>
            <div className="mt-1 h-2 bg-[#14171A] border border-[#24272B] overflow-hidden">
              <div className="h-full bg-[#E8E6E1]" style={{ width: `${Math.min(100, responses[d.deal_id].oversub.pct)}%` }} />
            </div>
            <span className={`t-cap ${responses[d.deal_id].oversub.pct >= 100 ? "text-bone font-semibold" : "text-muted-s"}`}>
              {responses[d.deal_id].oversub.pct}% subscribed{responses[d.deal_id].oversub.pct >= 100 ? ", oversubscribed" : ""}
            </span>
          </div>
        ) : null}
        <table className="table-solera mt-2">
          <thead><tr><th>Member</th><th>Response</th><th>When</th></tr></thead>
          <tbody>
            {responses[d.deal_id].responses.map((r) => (
              <tr key={r.response_id}>
                <td className="text-bone">{r.member_name}</td>
                <td className={r.response === "commit" ? "!text-[#C69A4E] font-semibold" : r.response === "interested" ? "text-bone font-semibold" : "text-muted-s"}>{r.response === "commit" ? "committed" : r.response}</td>
                <td className="text-muted-s t-small">{r.responded_at ? new Date(r.responded_at).toLocaleDateString() : "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {(() => {
          const wl = responses[d.deal_id].responses
            .filter((r) => r.response === "interested" || r.response === "commit")
            .sort((a, b) => (a.responded_at || "").localeCompare(b.responded_at || ""));
          return wl.length > 0 ? (
            <div className="mt-4" data-testid="announce-waitlist">
              <span className="t-label">Waitlist, earliest first</span>
              <div className="flex items-center gap-3 flex-wrap mt-2">
                <input type="number" className="input-solera fig max-w-[160px]" placeholder="Cap USD (optional)"
                  value={allocCap} onChange={(e) => setAllocCap(e.target.value)} data-testid="allocate-all-cap-input" />
                <button className="btn-ghost !py-1" disabled={busy} onClick={() => allocateAll(d.deal_id)} data-testid="allocate-all-button">Allocate all in order</button>
              </div>
              <ol className="mt-2 space-y-1">
                {wl.map((r, i) => (
                  <li key={r.response_id} className="flex items-center gap-3 t-small">
                    <span className="fig text-muted-s w-6">{i + 1}.</span>
                    <span className="text-bone">{r.member_name}</span>
                    {r.response === "commit" && <span className="t-cap !text-[#C69A4E]">committed</span>}
                    <span className="text-muted-s t-cap">{r.responded_at ? new Date(r.responded_at).toLocaleString() : ""}</span>
                    {r.allocated ? (
                      <span className="t-cap text-bone">Allocated</span>
                    ) : (
                      <button className="t-label hover:!text-[#E8E6E1]" onClick={() => allocateWaitlist(d.deal_id, r.user_id)} data-testid={`allocate-${r.user_id}`}>Allocate</button>
                    )}
                  </li>
                ))}
              </ol>
            </div>
          ) : null;
        })()}
      </div>
    )}
  </div>
);
